

define(['angular', 'squid/index', './miniBrowser', 'components/xo-locale/dist/index', 'components/xo-models/src/checkout/index', 'components/xo-models/src/app/index', 'components/xo-models/src/onboard/index', 'components/xo-models/src/auth/lib/xoAPayUtils'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.lib.middleware', ['squid', 'xolocale', 'xomodel.checkout', 'xomodel.app', 'xomodel.user', 'xomodel.onboard']).factory('$Middleware', function ($rootScope, $q, $util, $LocaleResolver, $CheckoutAppDataModel, $CheckoutCartModel, $GuestUpgradeModel, $CheckoutInputDataModel, $CheckoutClientDataModel, $CheckoutPayeeModel, $config, $meta, $pxp, $MiniBrowser, $FallbackError, $locale, $populate, $promise, $feature, $featureCountries, $AuthModel, $window, $timeout, $experiment, $TransactionEligibilityModel, $logger, $dispatch, $xoAPayUtils) {

        return [function checkToken() {
            var urlToken = $util.param('token');
            var bodyToken = $meta.token;
            // wps tokens are not preceeded with 'EC-'
            var wpsPattern = /^[0-9A-Z]{17}$/;

            if (urlToken !== $meta.token) {
                $logger.error('token_mismatch', {
                    server: $meta.token,
                    client: urlToken
                });
            }

            if (!urlToken && !bodyToken && !$util.param('data')) {
                throw new Error('No token or data found in page url');
            }

            // first set regular token (EC transactions)
            $rootScope.token = bodyToken || urlToken;

            $window.root = $rootScope;

            // now test for WPS, set flags as necessary and log.
            // make sure ebay transactions aren't counted
            var isEbay = $CheckoutInputDataModel.instance($rootScope.token).isEbayTxn();

            // identify WPS vs checkout-order token
            if (!isEbay && wpsPattern.test($rootScope.token)) {
                return $CheckoutAppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
                    // For WPS tokens appData.is_wps_flow() will always return 'true'.
                    if (appData.is_wps_flow()) {
                        $logger.info('xoon_wps_flow', {
                            token: $rootScope.token
                        });
                    } else {
                        $logger.info('xoon_xo_order_flow', {
                            token: $rootScope.token
                        });
                    }
                });
            }
        }, function resolveLocale() {

            var models = {};

            if ($rootScope.token) {
                return $populate(models, {
                    appData: $CheckoutAppDataModel.instance($rootScope.token).retrieve({
                        contingencies: {
                            DEFAULT: angular.noop
                        }
                    }),
                    cart: $CheckoutCartModel.instance($rootScope.token)
                })['finally'](function () {
                    return $locale.retrieve({
                        params: {
                            ipCountry: $meta.ipcountry,
                            localeTestUrlParam: $util.param('locale.test'),
                            checkoutBillingCountry: models.cart.get('payer_info.billing_address.country_code'),
                            checkoutShippingCountry: models.cart.get('purchase.shipping_address.country_code'),
                            merchantCountry: models.appData.get('merchant.merchant_country'),
                            checkoutSessionLocale: models.appData.get('merchant.merchant_locale'),
                            countryParam: $util.param('country.x'),
                            localeParam: $util.param('locale.x')
                        }
                    });
                });
            } else if ($util.param('data')) {
                var options = {
                    params: {
                        data: $util.param('data')
                    }
                };

                return $populate(models, {
                    guestAccountData: $GuestUpgradeModel.instance().retrieve({
                        options: options,
                        contingencies: {
                            MAYFLY_ERROR: angular.noop,
                            DEFAULT: angular.noop
                        }
                    })
                }).then(function () {
                    return $locale.retrieve({
                        params: {
                            ipCountry: $meta.ipcountry,
                            localeTestUrlParam: $util.param('locale.test'),
                            countryParam: models.guestAccountData.get('user.country')
                        }
                    });
                });
            }
        }, function logout() {
            return $AuthModel.instance().retrieve().then(function (auth) {
                if (auth.logged_in || auth.email) {
                    return auth.action('logout');
                }
            });
        }, function checkTransactionEligibility() {
            // skip XOE call for prox upgrade and prox sign up flows
            // prox upgrade identification - data is a query param in the url for prox upgrade
            // prox signup flow identification - ebay flag from $CheckoutInputDataModel indicates prox signup flow.
            if ($rootScope.token && $CheckoutInputDataModel.instance($rootScope.token).isEbayTxn()) {
                return $logger.info('prox_transaction_ignore_XOE_CALL');
            } else if ($util.param('data')) {
                return $logger.info('prox_upgrade_transaction_ignore_XOE_CALL');
            } else {
                return $promise.hash({
                    transactionEligibility: $TransactionEligibilityModel.instance($rootScope.token).retrieve()
                }).then(function (data) {
                    if (data.transactionEligibility.eligible && !data.transactionEligibility.lipp) {
                        return $logger.info('transaction_eligible');
                    }

                    $logger.info('transaction_ineligible');

                    return $q.reject(new $FallbackError({
                        reason: 'transaction_ineligible',
                        product: 'ux'
                    }));
                });
            }
        },

        /**
         * Redirect back to Hermes if Android user with PayPal available through Android pay who
         * landed on Xoon due to BASL. 2 checks need to be done to determine if user has PayPal
         * in Android pay wallet: 1. chrome version >=58 (this version support payment api)
         * 2. call canMakePayment api call to validate if PayPal is already available in Android pay
         */
        function checkAPayBASLRedirect() {
            if (!$config.apayEnabled) {
                return;
            }
            // Check if browser supports PaymentRequest API.
            if (!$xoAPayUtils.isAPayAPISupported()) {
                return;
            }

            var models = {};

            return $populate(models, {
                cart: $CheckoutCartModel.instance($rootScope.token).retrieve()
            }).then(function () {
                // Do nothing for APay onboarding flow.
                if (models.cart.isWalletTokenization()) {
                    return;
                }

                // Call PaymentRequest API to check if paypal as payment available
                return $xoAPayUtils.canMakeAPayPayment().then(function (result) {
                    if (result) {
                        return $dispatch('hermes', {
                            token: $rootScope.token,
                            hermesLoginRedirect: 'xoon',
                            'locale.x': $locale.lang + '_' + $locale.country,
                            'country.x': $locale.country
                        });
                    }
                    return;
                });
            });
        }, function xcomponent() {

            if (window.xprops && window.xprops.init) {

                return $q.all([$CheckoutAppDataModel.instance($rootScope.token).retrieve(), $CheckoutPayeeModel.instance($rootScope.token).retrieve()]).then(function (_ref) {
                    var checkoutAppData = _ref[0],
                        checkoutPayee = _ref[1];


                    return window.xprops.init({
                        paymentToken: $rootScope.token,
                        merchantID: checkoutPayee.merchant.id,
                        cancelUrl: checkoutAppData.urls.cancel_url
                    });
                });
            }
        }, function updateMerchantData() {
            if ($CheckoutInputDataModel.instance($rootScope.token).isEbayTxn()) {
                return $CheckoutAppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
                    return $CheckoutClientDataModel.instance($rootScope.token).retrieve().then(function (clientData) {
                        var checkoutInputData = $CheckoutInputDataModel.instance($rootScope.token);
                        var identityData = clientData.merchantIdentityData();

                        appData.merchant = {
                            merchant_email: identityData.email,
                            brand_name: identityData.brand_name,
                            logo_url: identityData.logo_uri
                        };

                        appData.urls = {
                            cancel_url: checkoutInputData.errorUrl('user_cancelled')
                        };
                    });
                });
            }
        }, function checkJavaScriptInjection() {
            if ($CheckoutInputDataModel.instance($rootScope.token).isEbayTxn()) {
                $logger.info('prox_signup_start', { cart_id: $rootScope.token });
                var redirectUri = $util.param('redirect_uri');

                if (redirectUri && redirectUri.indexOf('http') !== 0) {
                    $logger.warn('XOON_FLOW_INVALID_REDIRECT_URI_JAVASCRIPT_INJECTION', {
                        uri: redirectUri
                    });
                    return $q.reject(new $FallbackError({
                        reason: 'invalidRedirectURI',
                        product: 'ux'
                    }));
                }
            }
        }, function verifyRedirectURI() {
            if ($CheckoutInputDataModel.instance($rootScope.token).isEbayTxn()) {
                var redirectUri = $util.param('redirect_uri');

                return $CheckoutClientDataModel.instance($rootScope.token).retrieve().then(function (clientData) {
                    var isValidUri = clientData.validateRedirectUri(redirectUri) || {};

                    if (!isValidUri.success) {
                        $logger.warn('XOON_FLOW_INVALID_REDIRECT_URI', {
                            uri: redirectUri
                        });
                        return $q.reject(new $FallbackError({
                            reason: 'invalidRedirectURI',
                            product: 'ux'
                        }));
                    }
                });
            }
        },

        // allow PROX to support country content separate from Hermes
        function proxFallbackManager() {
            if ($CheckoutInputDataModel.instance($rootScope.token).isEbayTxn()) {
                $featureCountries('guestFallback').forEach(function (country, index) {
                    $config.features[country].guestFallback = false;
                });
            }
        }, function handleTagManager() {

            $window.dataLayer = {
                // Two letter country code of the current page's content
                contentCountry: $locale.country.toLowerCase(),
                // Two letter locale
                contentLanguage: $locale.lang.toLowerCase()
            };

            var tagManagerUrl = '//www.paypalobjects.com/tagmgmt/bootstrap.js';

            // Based on the environment, Tag Manager end point can be changed. For now the local and stage end points are same.
            if ($window.location.href.indexOf('qa.paypal.com') > -1 || $window.location.href.indexOf('localhost') > -1) {
                tagManagerUrl = '//nexus.ensighten.com/paypal/stage/Bootstrap.js';
            }
            (function (i, s, o, g, r, a, m) {
                i.tagManagerObjec = r;
                i[r] = i[r] || function () {
                    (i[r].q = i[r].q || []).push(arguments);
                };
                i[r].l = 1 * new Date();
                a = s.createElement(o);
                m = s.getElementsByTagName(o)[0];
                a.async = 1;
                a.src = g;
                m.parentNode.insertBefore(a, m);
            })($window, document, 'script', tagManagerUrl, 'tagManager');
        }, function setupMiniBrowser() {
            if ($util.param('data')) {
                return $MiniBrowser.initialize($util.param('cancel_url'));
            }

            return $CheckoutAppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
                return $MiniBrowser.initialize(appData.urls.cancel_url);
            });
        }, function logStart() {
            $logger.info('app_start_design', {
                is_directintegration: $MiniBrowser.isDirectIntegration ? 1 : 0,
                is_incontext: $MiniBrowser.isMiniBrowser || $MiniBrowser.isFrame ? 1 : 0
            });
        }, function checkWpsSubscriptionEligibility() {
            return $CheckoutAppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
                if (appData && appData.is_wps_subscription_flow()) {
                    return $pxp('xo_subscription_hermes_xoon', { 'ctx.COUNTRY': $locale.country }, 'xo_subscription_treatment_xoon').then(function (result) {
                        var treatmentName = result && result.treatment_name;
                        if (treatmentName !== 'xo_subscription_treatment_xoon') {
                            return $q.reject(new $FallbackError({
                                reason: 'fallback_wps_subscription_pxp_control',
                                product: 'ux'
                            }));
                        }
                    });
                }
            });
        }];
    });
});


//////////////////
// WEBPACK FOOTER
// ./js/lib/middleware.js
// module id = ./js/lib/middleware.js
// module chunks = 1